const actions = {
    FETCH_HOLIDAY_DECLARATIONS: 'FETCH_HOLIDAY_DECLARATIONS',
    FETCH_HOLIDAY_DECLARATION: 'FETCH_HOLIDAY_DECLARATION',
    RESET_HOLIDAY_DECLARATION: 'RESET_HOLIDAY_DECLARATION',

    fetchHolidayDeclarationsAction: (data) => {
        return {
            type: actions.FETCH_HOLIDAY_DECLARATIONS,
            data: data
        };
    },
    resetHolidayDeclarationFormAction: () => {
        return {
            type: actions.RESET_HOLIDAY_DECLARATION,
            data: null
        };
    },
    fetchHolidayDeclarationAction: (data) => {
        return {
            type: actions.FETCH_HOLIDAY_DECLARATION,
            data: data
        };
    },
};

export default actions;